import { useState } from "react";
import { Button } from "components/DesignSystem/Button/Button";
import Dropdown from "components/DesignSystem/Dropdown/Dropdown";
import { MenuDotsVertical } from "components/icons/MenuDotsVertical";
import { Tick } from "components/icons/Tick";

type TimelineYearMenuProps = {
  years: number[];
  viewYear: number;
  onSelectYear: (year: number) => void;
};

export const TimelineYearMenu = ({
  years,
  viewYear,
  onSelectYear,
}: TimelineYearMenuProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelectYear = (year: number) => () => {
    onSelectYear(year);
    setIsOpen(false);
  };

  return (
    <Dropdown.Root open={isOpen} onOpenChange={setIsOpen}>
      <Dropdown.Trigger asChild>
        <div>
          <Button
            customType="ghost_icon"
            size="small"
            aria-label="Timeline options"
          >
            <span className="t-flex t-text-neutral-40">
              <MenuDotsVertical />
            </span>
          </Button>
        </div>
      </Dropdown.Trigger>

      <Dropdown.Portal>
        <Dropdown.Content align="end" sideOffset={8}>
          <Dropdown.Sub>
            <Dropdown.SubTrigger disabled={years.length === 0}>
              Go to year
            </Dropdown.SubTrigger>

            <Dropdown.Portal>
              <Dropdown.SubContent sideOffset={4} alignOffset={-4}>
                {years.map((year) => (
                  <Dropdown.Item
                    key={year}
                    onSelect={handleSelectYear(year)}
                    tag={
                      year === viewYear ? (
                        <span className="t-flex t-text-purple">
                          <Tick width="12" height="12" />
                        </span>
                      ) : null
                    }
                  >
                    {year}
                  </Dropdown.Item>
                ))}
              </Dropdown.SubContent>
            </Dropdown.Portal>
          </Dropdown.Sub>
        </Dropdown.Content>
      </Dropdown.Portal>
    </Dropdown.Root>
  );
};
